import ApiService from '@/common/api.service'

const RESOURCE = 'page'
const PageService = {
  getFixed (code, params) {
    return ApiService.query(`${RESOURCE}/fixed/${code}`, params)
  },
  getAdded (code, params) {
    return ApiService.query(`${RESOURCE}/added/${code}`, params)
  },
  getPreview (code, params) {
    return ApiService.query(`${RESOURCE}/preview/${code}`, params)
  }
}
export default PageService
